var _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7, _path8, _circle2, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 121,
    viewBox: "0 0 108 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.465 47V70",
    stroke: "#6ECDA9",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.965 88L41.9651 107",
    stroke: "#6ECDA9",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 47.4494L24.8616 107.475",
    stroke: "#6ECDA9",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7075 71.4232L58.9646 47",
    stroke: "#6ECDA9",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 91,
    r: 27.5,
    stroke: "#6ECDA9",
    strokeWidth: 5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 118L6.50204 118.101L6.59911 120.5H9V118ZM7.99796 31.3989C7.94213 30.0193 6.77851 28.9462 5.39893 29.002C4.01934 29.0579 2.94622 30.2215 3.00204 31.6011L7.99796 31.3989ZM72 115.5H9V120.5H72V115.5ZM11.498 117.899L7.99796 31.3989L3.00204 31.6011L6.50204 118.101L11.498 117.899Z",
    fill: "#6ECDA9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 20C2.5 16.9624 4.96243 14.5 8 14.5H73C76.0376 14.5 78.5 16.9624 78.5 20V30.5H2.5V20Z",
    stroke: "#6ECDA9",
    strokeWidth: 5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 8C22.5 4.96243 24.9624 2.5 28 2.5H53C56.0376 2.5 58.5 4.96243 58.5 8V14.5H22.5V8Z",
    stroke: "#6ECDA9",
    strokeWidth: 5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76 32L75 62.5",
    stroke: "#6ECDA9",
    strokeWidth: 5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 79,
    r: 3,
    fill: "#6ECDA9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5 81C84.5 81 79.5 72.5 78 72.5C76 72.5 72 79.5 72 79.5",
    stroke: "#6ECDA9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9683 77.8894C66.9727 76.9125 68.0802 76.3499 68.8717 76.9226L75.3328 81.5973C76.1214 82.168 75.9382 83.3907 75.017 83.7052L68.5253 85.9211C67.7446 86.1876 66.934 85.605 66.9377 84.7801L66.9683 77.8894Z",
    fill: "#6ECDA9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2645 101.525C82.2645 101.525 92.1227 101.784 92.9169 100.512C93.9759 98.8149 90.1559 91.7151 90.1559 91.7151",
    stroke: "#6ECDA9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1864 88.2995C95.0129 88.8205 94.9037 90.058 93.9988 90.4262L86.6119 93.4318C85.7103 93.7986 84.77 92.9958 84.991 92.0477L86.5487 85.3675C86.7361 84.5641 87.6595 84.1849 88.3573 84.6248L94.1864 88.2995Z",
    fill: "#6ECDA9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2564 89.2318C64.2564 89.2318 59.6038 97.9269 60.385 99.2074C61.4265 100.915 69.4855 100.684 69.4855 100.684",
    stroke: "#6ECDA9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7309 105.819C69.8946 106.324 68.8375 105.671 68.9142 104.697L69.5404 96.7468C69.6168 95.7764 70.7561 95.296 71.5043 95.9187L76.7767 100.307C77.4107 100.834 77.3355 101.83 76.6294 102.256L70.7309 105.819Z",
    fill: "#6ECDA9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.766905b833c4f2feee7be91e432aa6d5.svg";
export { ForwardRef as ReactComponent };